<template>
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
        >保存</el-button
      >
    </div>
    <div class="formbox">
      <el-form class="glo_formBox" label-width="120px">
        <el-form-item label="发车批次:">
          <el-input
            v-model="number"
            disabled
            placeholder="自动带入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          style="width: 500px"
          required
          class="dialogFormItems"
          label="结算对象:"
        >
          <div class="multipleSelect">
            <el-select
              filterable
              clearable
              v-model="dialogForm.objectStatusType"
              placeholder="请选择"
              @change="changeObjestStatusYS"
            >
              <el-option
                v-for="item in objectStatusList"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-select
              filterable
              clearable
              v-model="dialogForm.objectName"
              placeholder="请选择"
              remote
              :allow-create="dialogForm.objectStatusType == 'other'"
              :remote-method="getObjectUserDownListYf"
              @change="changeobjectName"
            >
              <el-option
                v-for="item in CustomerListsYF"
                :key="item.number"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item class="dialogFormItems" required label="付款方式:">
          <el-select
            filterable
            clearable
            v-model="dialogForm.paymentMethodConfDictId"
            placeholder="请选择"
            @change="changePayMent1"
          >
            <el-option
              v-for="item in settlementMethodList"
              :key="item.confDictId"
              :label="item.val"
              :value="item.confDictId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="dialogFormItems" required label="垫付人:">
          <el-select
            filterable
            clearable
            v-model="dialogForm.preparerEmployeeId"
            placeholder="请选择"
            remote
            :remote-method="
              (val) => {
                getemployee(val);
              }
            "
            @focus="getemployee()"
          >
            <el-option
              v-for="(item, index) in employeeList"
              :key="index"
              :label="item.name"
              :value="Number(item.documentId)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList52">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="openDialog"
          >添加费项</el-button
        >
      </div>
    </div>
    <div class="glo_Table">
      <el-table
        header-align="center"
        ref="mytable51"
        :data="tableData51"
        border
        stripe
        @selection-change="handleSelectionChange51"
        show-summary
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <!-- <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>-->
        <template v-for="(item, index) in myTableHeard5">
          <el-table-column
            v-if="item.field == 'tupian' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="clickSeeImg(scope.row)">
                查看
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column label="操作" align="center" sortable min-width="80">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                @click="editDialog(scope.row, scope.$index)"
                >编辑</el-button
              >
              <el-button class="rbtns" @click="delIconsYF(scope.$index)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 添加费项  -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      :isAppend="true"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog"
          ref="dialogFormRef"
          label-width="100px"
        >
          <el-form-item
            style="width: 500px"
            required
            class="dialogFormItems"
            label="费项:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm1.itemCategoryId"
                placeholder="请选择"
                @change="changeItemCategoryId"
              >
                <el-option
                  v-for="item in categoryNameList"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm1.itemServiceId"
                placeholder="请选择"
                @change="changeItemServiceId"
              >
                <el-option
                  v-for="item in CategoryServiceList"
                  :key="item.itemServiceId"
                  :label="item.title"
                  :value="item.itemServiceId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="dialogFormItems" required label="金额:">
            <el-input
              v-model="dialogForm1.amount"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm1.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图片:">
            <uploadimgs
              @input="changeFileList_zh"
              :fileNameLists="fileNameLists1"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 大图预览 -->
    <el-dialog
      :title="titleH"
      :visible.sync="bigImgsShow"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <div class style="display: flex">
        <div v-for="(item, index) in srcList" :key="index">
          <el-image
            style="width: 180px; height: 180px; margin: 10px"
            :src="item"
            :preview-src-list="srcList"
          ></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="bigImgsShow = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";

export default {
  components: {
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      employeeList: [],
      tableData51: [],
      delTb51: [],

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "40%",
      dialogType: "",
      tableType: "",
      dialogForm: {
        // 弹窗表单数据
        fileIds: [],
        amount: "",
        inoutStatus: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethodConfDictName: "", //付款方式名称(我自己加的)
        preparerEmployeeId: "",
      },

      dialogForm1: {
        // 弹窗表单数据
        fileIds: [],
        amount: "",
        inoutStatus: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        objectName: "",
        objectNumber: "",
        objectStatusConfDictId: "",
        paymentMethodConfDictId: "",
        remarks: "",
        objectStatusType: "", //对象类型(我自己加的)
        paymentMethodConfDictName: "", //付款方式名称(我自己加的)
        preparerEmployeeId: "",
      },
      // ==== 弹窗组件属性 end ====

      myTableHeard5: [
        {
          name: "费项类型",
          field: "itemCategoryName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "费项",
          field: "itemServiceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "金额",
          field: "amount",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "图片",
          field: "tupian",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],

      objectStatusList: [],
      settlementMethodList: [],
      categoryNameList: [],
      CustomerListsYF: [], //对象列表
      CategoryServiceList: [],

      editIdx: 0,

      dispatchId: "",
      fileNameLists1: [],

      srcList: [],
      showFilse: false,
      bigImgsShow: false,
      titleH: "预览图片",
      financeIds1: [],

      number: "",
    };
  },

  created() {
    this.itemCategorChoose(); //费型类型下拉列表
    this.getConfDictValDownList("object_status"); //结算对象类型
    this.getConfDictValDownList("settlement_method");
  },
  mounted() {},
  activated() {
    let { dispatchId, number } = this.$route.query;
    if (dispatchId) {
      this.dispatchId = dispatchId;
      this.number = number;
      this.wtl_getDispatchFinance();
    }
  },
  destroyed() {},
  methods: {
    // 获取员工 employee
    getemployee(name) {
      return this.$API
        .wtl_getObjectUserDownList({
          key: "employee",
          name: name || "",
          pageStart: 1,
          pageTotal: 50,
        })
        .then((res) => {
          this.employeeList = res.data.result.data || [];
        });
    },
    // 保存财务信息
    submit() {
      if (!this.dialogForm.paymentMethodConfDictId) {
        this.$message.error("付款方式不能为空");
        return false;
      }
      if (!this.dialogForm.objectName) {
        this.$message.error("结算对象不能为空");
        return false;
      }
      this.objectStatusList.forEach((item) => {
        if (item.confDictId == this.dialogForm.objectStatusConfDictId) {
          this.dialogForm.objectStatusType = item.key;
        }
      });
      let arrs = JSON.parse(JSON.stringify(this.tableData51));
      let financeOutReqs = [...arrs, ...this.delTb51]; //删除的也要提交
      console.log("financeOutReqs", financeOutReqs);
      financeOutReqs.forEach((item) => {
        item.paymentMethodConfDictId = this.dialogForm.paymentMethodConfDictId;
        item.paymentMethodConfDictName = this.dialogForm.paymentMethodConfDictName;
        item.objectName = this.dialogForm.objectName;
        item.objectNumber = this.dialogForm.objectNumber;
        item.objectStatusConfDictId = this.dialogForm.objectStatusConfDictId;
        item.objectStatusType = this.dialogForm.objectStatusType;
        item.preparerEmployeeId = this.dialogForm.preparerEmployeeId;

        delete item.paymentMethod;

        if (item.fileIds && item.fileIds.length > 0) {
          item.fileIds = item.fileIds.map((item) => {
            return item.name;
          });
        } else {
          item.fileIds = [];
        }
      });

      // financeOutReqs.forEach((item) => {
      //   item.paymentMethodConfDictId = this.dialogForm.paymentMethodConfDictId;
      //   item.paymentMethod = this.dialogForm.paymentMethodConfDictName;
      //   if (this.financeIds1.includes(item.financeId)) {
      //   } else {
      //     item.operationType = "ADD";
      //   }
      //   if (item.fileIds && item.fileIds.length > 0) {
      //     item.fileIds = item.fileIds.map((item) => {
      //       return item.name;
      //     });
      //   } else {
      //     item.fileIds = [];
      //   }
      // });
      let param = {
        dispatchId: this.dispatchId,
        financeInReqs: [],
        financeOutReqs: financeOutReqs,
      };
      this.$API.wtl_saveDispatchFinance(param).then((res) => {
        this.$message.success(res.data.result || "操作成功");
        let that = this;
        this.delTb51 = [];
        this.tableData51 = [];
        this.number = "";
        this.dialogForm = {
          // 弹窗表单数据
          fileIds: [],
          amount: "",
          inoutStatus: "",
          itemCategoryId: "",
          itemCategoryName: "",
          itemServiceId: "",
          itemServiceName: "",
          objectName: "",
          objectNumber: "",
          objectStatusConfDictId: "",
          paymentMethodConfDictId: "",
          remarks: "",
          objectStatusType: "", //对象类型(我自己加的)
          paymentMethodConfDictName: "", //付款方式名称(我自己加的)
          preparerEmployeeId: "",
        };
        this.$TOOLS.closePage();
        this.$router.push({
          path: "/DispatchCar/VehicleStowage",
          query: {
            isreload: "isreload",
          },
        });
      });
    },
    // 获取财务信息
    wtl_getDispatchFinance() {
      this.$API
        .wtl_getDispatchFinance({ dispatchId: this.dispatchId })
        .then(async (res) => {
          console.log("aaaa", res);
          // _.cloneDeep(this.itemReqs)
          let { financeOutVos } = res.data.result;
          financeOutVos.forEach((item) => {
            item.operationType = "UPDATE";
          });

          let jsondata = JSON.parse(JSON.stringify(financeOutVos))
          this.tableData51 =jsondata ; //应付
          if (jsondata.length > 0) {
            this.dialogForm.objectStatusConfDictId =
            jsondata[0].objectStatusConfDictId;
            // this.dialogForm.objectStatusType = jsondata[0].objectStatus;
            this.dialogForm.paymentMethodConfDictId =
            jsondata[0].paymentMethodConfDictId;
            this.dialogForm.paymentMethodConfDictName =
            jsondata[0].paymentMethod;
            this.dialogForm.paymentMethodConfDictName =
            jsondata[0].paymentMethod;
            this.dialogForm.objectNumber = jsondata[0].objectNumber;
            this.dialogForm.objectName = jsondata[0].objectName;
            this.objectStatusList.forEach((item) => {
              if (item.confDictId == this.dialogForm.objectStatusConfDictId) {
                this.dialogForm.objectStatusType = item.key;
              }
            });
            await this.getemployee(jsondata[0].preparerEmployeeName);
            this.dialogForm.preparerEmployeeId =
              jsondata[0].preparerEmployeeId;
            await this.getObjectUserDownListYf(this.dialogForm.objectName);
          } else {
            this.dialogForm.objectStatusConfDictId = "";
            this.dialogForm.objectStatusType = "";
            this.dialogForm.paymentMethodConfDictId = "";
            this.dialogForm.paymentMethodConfDictName = "";
            this.dialogForm.objectNumber = "";
            this.dialogForm.objectName = "";
            this.dialogForm.preparerEmployeeId = "";
          }

          // this.financeIds1 = financeOutVos.map((n) => {
          //   return n.financeId;
          // });
        });
    },
    clickSeeImg(row) {
      let { fileIds } = row;
      this.srcList = fileIds.map((item) => {
        return item.url;
      });
      this.bigImgsShow = true;
    },
    // 选择图片(装货确认)
    changeFileList_zh(array) {
      this.fileNameLists1 = array;
    },

    //选择费项类型()
    changeItemCategoryId(e) {
      this.dialogForm1.itemServiceId = "";
      this.dialogForm1.amount = "";
      this.dialogForm1.itemServiceName = "";
      if (e) {
        let direction_status = "fu:direction_status";
        this.wtl_itemServiceListAll(e, direction_status);
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm1.itemCategoryName = item.categoryName;
          }
        });
      }
    },
    //选择费项
    changeItemServiceId(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm1.amount = item.unitPrice;
            this.dialogForm1.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm1.amount = "";
        this.dialogForm1.itemServiceName = "";
      }
    },
    // 根据类别和费项类型获取费项
    wtl_itemServiceListAll(e, directionStatus) {
      this.$API
        .wtl_getCategoryServiceList({
          categoryId: e || "",
          directionStatus: directionStatus || "",
        })
        .then((res) => {
          this.CategoryServiceList = res.data.result || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm.objectNumber = item.number;
            // this.dialogForm.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    // 选择结算对象类型(
    changeObjestStatusYS(e) {
      console.log("eeee", e);
      this.dialogForm.objectName = "";
      this.dialogForm.objectNumber = "";
      this.dialogForm.objectStatusConfDictId = "";
      if (e) {
        this.getObjectUserDownListYf();
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.dialogForm.objectStatusConfDictId = item.confDictId;
          }
        });
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      let objectStatusType = this.dialogForm.objectStatusType;

      this.$API
        .wtl_getObjectUserDownList({
          key: objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    //选择付款方式(应付弹窗)
    changePayMent1(e) {
      if (e) {
        this.settlementMethodList.forEach((item) => {
          if (item.confDictId == e) {
            this.dialogForm.paymentMethodConfDictName = item.val;
          }
        });
      } else {
        this.dialogForm.amount = "";
        this.dialogForm.itemServiceName = "";
      }
    },
    // 编辑应付
    editDialog(val, idx, type) {
      this.tableType = type;
      this.dialogTitle = "编辑应付费项";
      this.dialogForm1.inoutStatus = "zhi_chu:deal_status";
      if (this.tableData51[idx].operationType == "ADD") {
        this.dialogType = "addEit";
      } else {
        this.dialogType = "edit";
      }

      this.editIdx = idx;
      // this.tableData51[idx].operationType = "UPDATE";
      if (
        this.tableData51[idx].fileIds &&
        this.tableData51[idx].fileIds.length > 0
      ) {
        this.fileNameLists1 = this.tableData51[idx].fileIds.map((item) => {
          return {
            name: item.name,
            url: item.url,
          };
        });
      } else {
        this.fileNameLists1 = [];
      }
      this.objectStatusList.forEach((item) => {
        if (item.confDictId == this.dialogForm.objectStatusConfDictId) {
          val.objectStatusType = item.key;
        }
      });
      this.changeItemCategoryId(val.itemCategoryId);
      
      this.$nextTick(() => {
        console.log("val", val);
        this.dialogForm1 = JSON.parse(JSON.stringify(val));
        this.isShowDialog = true;
      });
    },

    // 新建应付应收
    openDialog(val) {
      const {
        objectStatusType,
        objectName,
        paymentMethodConfDictId,
      } = this.dialogForm;
      if (!objectStatusType || !objectName) {
        this.$message.error("请选择结算对象");
        return false;
      }
      if (!paymentMethodConfDictId) {
        this.$message.error("请选择付款方式");
        return false;
      }
      this.dialogTitle = "添加应付费项";
      this.dialogForm1.inoutStatus = "zhi_chu:deal_status";
      this.tableType = val;
      this.dialogType = "add";
      this.isShowDialog = true;
    },
    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
          }
          if (dictType == "receive_method") {
            // 获取收货方式列表
            this.ReceivingMethodList = arrs;
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs || [];

            //
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
        });
    },
    // 删除应付
    delIconsYF(idx) {
      this.$confirm("确定要删除该行信息吗?", "提示:")
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tableData51)) || [];
          let delTb51 = JSON.parse(JSON.stringify(this.delTb51)) || [];
          if (datas[idx].operationType !== "ADD") {
            datas[idx].operationType = "DEL";
            delTb51.push(datas[idx]);
            this.delTb51 = delTb51;
          }
          datas.splice(idx, 1);
          this.tableData51 = datas;
        })
        .catch(() => {});
    },

    // 表格选择事件(第五步,应付)
    handleSelectionChange51(e) {
      this.selectTableData51 = e;
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm1 = {
        fileIds: [],
        amount: "",
        inoutStatus: "",
        itemCategoryId: "",
        itemCategoryName: "",
        itemServiceId: "",
        itemServiceName: "",
        remarks: "",
        objectName: this.dialogForm.objectName,
        objectNumber: this.dialogForm.objectNumber,
        objectStatusConfDictId: this.dialogForm.objectStatusConfDictId,
        paymentMethodConfDictId: this.dialogForm.paymentMethodConfDictId,
        objectStatusType: this.dialogForm.objectStatusType, //对象类型(我自己加的)
        paymentMethodConfDictName: this.dialogForm.paymentMethodConfDictName, //付款方式名称(我自己加的)
        preparerEmployeeId: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      // this.dialogForm.fileIds = this.fileNameLists1.map((item) => {
      //   return item.name;
      // });
      this.dialogForm1.fileIds = this.fileNameLists1;
      let objs = JSON.parse(JSON.stringify(this.dialogForm1));
      let tableData51 = JSON.parse(JSON.stringify(this.tableData51));
      if (this.dialogType == "add") {
        objs.operationType = "ADD";
        tableData51.push(objs);
      } else if (this.dialogType == "addEit") {
        objs.operationType = "ADD";
        tableData51[this.editIdx] = objs;
      } else {
        objs.operationType = "UPDATE";
        tableData51[this.editIdx] = objs;
      }
      this.tableData51 = tableData51;
      this.isShowDialog = false;
    },
  },
};
</script>
<style scoped lang="less">
.iconsRight10 {
  margin-right: 10px;
}
.iconsbtns {
  font-size: 26px;
  cursor: pointer;
}

// 查询条件边框线
@borderColor: #cccccc;
.h3title {
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid @borderColor;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}
.topBtns {
  width: calc(100% - 220px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}
.glo_btnList {
  margin-top: 16px;
}
</style>
